import React, { useState } from 'react';
import apiService from '../services/apiService';

function AdminLogin({ onLogin, language = 'en' }) {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // Authentification admin via l'API
      const response = await apiService.adminLogin(credentials.username, credentials.password);
      
      if (response.success) {
        // Stocker les tokens admin et les informations utilisateur
        localStorage.setItem('adminToken', response.accessToken);
        localStorage.setItem('refreshToken', response.refreshToken);
        localStorage.setItem('adminUser', JSON.stringify(response.user));
        
        // Appeler la fonction de connexion
        onLogin(response.user);
      } else {
        setError(response.message || (language === 'de' ? 'Ungültige Anmeldedaten' : 'Invalid credentials'));
      }
    } catch (error) {
      console.error('Erreur de connexion admin:', error);
      setError(error.message || (language === 'de' ? 'Ungültige Anmeldedaten' : 'Invalid credentials'));
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <div className="admin-login-logo">
            <span>👨‍⚕️</span>
          </div>
          <h1 className="admin-login-title">
            {language === 'de' ? 'Admin Portal' : 'Admin Portal'}
          </h1>
          <p className="admin-login-subtitle">
            {language === 'de' ? 'Patientenverwaltung' : 'Patient Management'}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && (
            <div className="error">
              <span>⚠️</span>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">
              {language === 'de' ? 'Benutzername' : 'Username'}
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              required
              placeholder={language === 'de' ? 'Benutzername eingeben' : 'Enter username'}
              autoComplete="off"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              {language === 'de' ? 'Passwort' : 'Password'}
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              required
              placeholder={language === 'de' ? 'Passwort eingeben' : 'Enter password'}
              autoComplete="off"
            />
          </div>

          <button 
            type="submit" 
            className="btn admin-login-btn"
            disabled={isLoading}
          >
            {isLoading ? (
              <span>🔄 {language === 'de' ? 'Anmelden...' : 'Logging in...'}</span>
            ) : (
              <span>🔐 {language === 'de' ? 'Anmelden' : 'Login'}</span>
            )}
          </button>
        </form>

        <div className="admin-login-footer">
          <p>
            {language === 'de' 
              ? 'Zugriff nur für autorisierte Administratoren' 
              : 'Access restricted to authorized administrators'
            }
          </p>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin; 